// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KHdo","col":"styles_col__3LF5B"};